import { render, staticRenderFns } from "./wstage.vue?vue&type=template&id=354ec33b&scoped=true&"
import script from "./wstage.vue?vue&type=script&lang=js&"
export * from "./wstage.vue?vue&type=script&lang=js&"
import style0 from "./wstage.vue?vue&type=style&index=0&id=354ec33b&scoped=true&lang=css&"
import style1 from "./wstage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ec33b",
  null
  
)

export default component.exports